// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__8nU-e","login":"LoginPage_login__VAmjT","google":"LoginPage_google__O9B5f","kakao":"LoginPage_kakao__RKzuD"};